module.exports = __webpack_public_path__ + "static/media/cours-co.81071254.svg";